const reqCredTypeOptions = [
  { label: "Initial", value: 1 },
  { label: "ReCred", value: 2 },
];

export default reqCredTypeOptions;
